import { useTranslations } from 'contexts/Translation'
import { Tabs, Card } from 'antd'
import { StickyContainer, Sticky } from 'react-sticky'
import {
  Container,
  Row,
  Col,
  Spin,
  Divider,
  Text,
  Title
} from '@qonsoll/react-design'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useStateWithStorage } from 'hooks'
import { TipTipStatus } from 'domains/Tip/components'
import PropTypes from 'prop-types'

const TipAdvancedView = (props) => {
  const { tip } = props

  /* State for active tab in AdvancedView with saving it to storage */
  const [activeTab, setActiveTab] = useStateWithStorage(
    null,
    'tip-advanced-view-active-tab'
  )
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting history instance from useHistory hook for redirecting */
  const history = useHistory()
  /* Getting params from useParams hook for getting url params */
  const params = useParams()
  /* Getting location from useLocation hook */
  const location = useLocation()
  /* Getting id from params */
  const { tipId } = params

  /* Getting TabPane component from Tabs */
  const { TabPane } = Tabs

  return (
    <Container>
      <Row mx="var(--ql-grid-gutter-negative)">
        <Col cw={4} mb={3}>
          <Card>
            <Row noGutters mb={2} v="center">
              <Col h="left">
                <Title level={5}>{tip?.title}</Title>
              </Col>
            </Row>
            <Row noGutters mb={2} v="center">
              <Col h="left">
                <Title level={5}>{tip?.name}</Title>
              </Col>
            </Row>
            <Row noGutters v="center" mb={2}>
              <Col h="left">
                <Text variant="overline" type="secondary">
                  {t('Sno')}:
                </Text>
              </Col>
              <Col h="right">
                <Text>{tip?.sno}</Text>
              </Col>
            </Row>
            <Row noGutters v="center" mb={2}>
              <Col h="left">
                <Text variant="overline" type="secondary">
                  {t('Location')}:
                </Text>
              </Col>
              <Col h="right">
                <Text>{tip?.location}</Text>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col cw={8} mb={3}>
          <Card>
            <Row noGutters v="center" mb={2}>
              <Col h="left">
                <Text fontWeight="bold">{t('Status')}:</Text>
              </Col>
              <Col cw="auto" h="right">
                <TipTipStatus
                  emptyProps={{ withIllustration: false, withCreate: false }}
                  tip={tip}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

TipAdvancedView.propTypes = {
  tip: PropTypes.object
}

export default TipAdvancedView
